var SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
export function transformActivitiesItems(query) {
  var activities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!activities || !activities.nodes) {
    return [];
  }
  return activities.nodes.map(function (item) {
    var object = item.object,
      timestamp = item.timestamp;
    var cloudId = object.cloudId,
      events = object.events,
      extension = object.extension,
      iconUrl = object.iconUrl,
      id = object.id,
      localResourceId = object.localResourceId,
      name = object.name,
      product = object.product,
      url = object.url,
      type = object.type;
    // V2 returns eventType captilised, V3 returns lowercase
    var eventType = events[0].eventType.toLowerCase();
    var issueKey = extension && extension.issueKey;
    var containers = [];
    if (issueKey) {
      containers.push({
        name: issueKey
      });
    }
    if (Array.isArray(object.containers)) {
      containers = containers.concat(object.containers);
    }
    containers = containers.filter(function (container) {
      return !!container.name;
    });
    return {
      query: query,
      containers: containers,
      contributors: (object.contributors || []).reduce(function (contributors, contributor) {
        if (contributor.profile) {
          var _contributor$profile = contributor.profile,
            accountId = _contributor$profile.accountId,
            picture = _contributor$profile.picture;
          contributors.push({
            accountId: accountId,
            name: contributor.profile.name,
            picture: picture
          });
        }
        return contributors;
      }, []),
      eventType: eventType,
      object: {
        rootContainerIdentifier: {
          id: cloudId,
          type: 'SITE',
          ari: "".concat(SITE_ARI_PREFIX).concat(cloudId)
        },
        deduplicateId: id,
        icon: {
          type: 'URL',
          value: iconUrl
        },
        id: id,
        localResourceId: localResourceId,
        name: name,
        product: product,
        subProduct: null,
        type: type,
        url: url
      },
      timestamp: timestamp
    };
  });
}